<template>
    <div class="ei-works-item">
        <div class="img">
            <a target="_blank" href="">
                <img :src="cover" alt="">
            </a>
            <span class="label">{{tag}}</span>
        </div>
        <div class="text">
            <div class="inner">
                <div class="tit">
                    <a class="t1" target="_blank" href="">{{name}}</a>
                </div>
                <div class="desc">
                    <p>{{desc}}</p>
                    <p class="authenticate">清鉴阁<span :class="{'label':true,warn:authenticate===1} ">{{authenticate===1?'鉴定':'同鉴'}}</span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EiWorksItem",
        props: {
            cover: {
                type: String,
                default: '/upload/works/s5efda91b6a6e9.jpg',
            },
            name: {
                type: String,
                default: '作品标题',
            },
            tag: {
                type: String,
                default: '神品',
            },
            desc: {
                type: String,
                default: '描述信息...',
            },
            authenticate: {
                type: Number,
                default: 1,
            }
        }
    }
</script>

<style scoped lang="scss">
    .ei-works-item {
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
        width: 413px;

        .img {
            height: 268px;
            overflow: hidden;
            position: relative;

            img {
                display: block;
                width: 100%;
                height: 100%;
                transition: transform 0.5s ease;

                &:hover {
                    transform: scale(1.2, 1.2)
                }
            }

            .label {
                background: #9d3938;
                color: #fff;
                display: inline-block;
                font-size: 14px;
                padding: 5px 10px;
                position: absolute;
                right: -1px;
                top: -1px;
                border-top-right-radius: 0;
            }
        }
    }

    .ei-works-item .text .inner {
        padding: 25px 30px
    }

    .ei-works-item .text .tit {
        height: 32px;
        line-height: 32px;
    }

    .ei-works-item .text {
        border: 1px solid #ddd
    }

    .ei-works-item .text .tit a {
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
    }

    .ei-works-item .text .tit a.t1 {
        font-size: 16px;
        max-width: 295px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 10px
    }

    .ei-works-item .text .desc {
        color: #999;
        margin-top: 10px;
        height: 50px;
        white-space: nowrap;
        overflow: inherit;
        text-overflow: ellipsis;

        .authenticate {
            margin-top: 10px;
            text-align: right;
            margin-right: -30px
        }
    }

    .ei-works-item .text .desc p {
        padding: 2px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ei-works-item .text .label.warn {
        background: #9d3938;
        border-radius: 3px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        margin: 0 10px;
        padding: 5px 10px
    }

    .ei-works-item .text .label {
        background: #6BB367;
        border-radius: 3px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        margin: 0 10px;
        padding: 5px 10px
    }

    .ei-works-item .text .label.c2 {
        background: #555
    }

    .ei-works-item .text .label.c3 {
        background: #9a7a50
    }

    .ei-works-item .text .label.c4 {
        background: #555
    }
</style>
